export const useSubscribe = (event, cb) => {
    return window.observer.subscribe(event, cb);
}

export const useUnSubscribe = (event, token) => {
    return window.observer.unSubscribe(event, token);
}

export const useDispatch = (event, data) => {
    return window.observer.dispatch(event, data);
}